export const SENDING_REQUEST = 'CLASIFIERGROUPSFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'CLASIFIERGROUPSFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'CLASIFIERGROUPSFORM_UPDATE_SUCCESS';
export const FAILURE = 'CLASIFIERGROUPSFORM_FAILURE';
export const RESET_FORM = 'CLASIFIERGROUPSFORM_RESET_FORM';